import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CategoryForm from '../../../../components/masters/styles/category/CategoryForm';
import CategoryTable from '../../../../components/masters/styles/category/CategoryTable';
import { addCategoryAction, updateCategoryAction, clearCategoryEdit } from '../../../../redux/actions/masters/styles/category/categoryAction';
import { fetchCategoryGroupsAction } from '../../../../redux/actions/masters/styles/categoryGroup/categoryGroupAction';
import { fetchUsers } from '../../../../redux/actions/masters/users/user/userAction';

const outerWrapper = {
  padding: 0,
  margin: 0,
  minHeight: 'calc(100vh - 72px)',
  display: 'flex',
  flexDirection: 'column',
  // background: 'transparent',
  marginTop: 24,
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: 24,
  alignItems: 'stretch',
  width: '100%',
  height: '100%',
  flex: 1,
};

const cardBase = {
  background: '#fff',
  borderRadius: 16,
  boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
  padding: '2rem 1.5rem',
  display: 'flex',
  flexDirection: 'column',
  // minWidth: 320,
  flex: 1,
  // minHeight: 520,
};

const formContainer = {
  ...cardBase,
  maxWidth: 400,
  flex: '0 1 400px',
  marginRight: 0,
};
const tableContainer = {
  ...cardBase,
  flex: 2,
  minWidth: 340,
  marginLeft: 0,
};

const responsiveStyle = `
@media (max-width: 900px) {
  .category-flex {
    flex-direction: column !important;
    gap: 20px !important;
  }
  .category-form, .category-table {
    max-width: 100% !important;
    min-width: 0 !important;
    width: 100% !important;
  }
}
`;

const CategoryPage = () => {
  const dispatch = useDispatch();
  const { editingCategory } = useSelector((state) => state.category);
  const categoryGroups = useSelector((state) => state.categoryGroup.list || []);
  const users = useSelector(state => state.users.list || []);
  const [formSuccess, setFormSuccess] = useState('');
  const [formError, setFormError] = useState('');
  const [formResetKey, setFormResetKey] = useState(0);

  useEffect(() => {
    dispatch(fetchCategoryGroupsAction());
    dispatch(fetchUsers());
  }, [dispatch]);

  const handleFormReset = () => {
    setFormResetKey(prev => prev + 1);
    setFormSuccess('');
    setFormError('');
  };

  const handleSubmit = async (form) => {
    try {
      if (editingCategory && editingCategory.category_id) {
        await dispatch(updateCategoryAction({ id: editingCategory.category_id, category: form }));
        setFormError('');
      } else {
        await dispatch(addCategoryAction(form));
        setFormError('');
      }
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message;
      if (
        err?.response?.status === 409 ||
        (message && message.toLowerCase().includes('already exists'))
      ) {
        setFormError('');
        throw err;
      }
      setFormError(message || 'An error occurred.');
      throw err;
    }
  };

  const handleCancel = () => {
    dispatch(clearCategoryEdit());
    setFormSuccess('');
    setFormError('');
  };

  return (
    <div style={outerWrapper}>
      <style>{responsiveStyle}</style>
      <div style={containerStyle} className="category-flex">
        <div style={tableContainer} className="category-table">
          <CategoryTable onNew={handleFormReset} categoryGroups={categoryGroups} />
        </div>
        <div style={formContainer} className="category-form">
          <CategoryForm
            key={formResetKey}
            onSubmit={handleSubmit}
            editingCategory={editingCategory}
            onCancel={handleCancel}
            formSuccess={formSuccess}
            formError={formError}
            setFormSuccess={setFormSuccess}
            setFormError={setFormError}
            categoryGroups={categoryGroups}
            users={users}
          />
        </div>
      </div>
    </div>
  );
};

export default CategoryPage; 